import { Chip } from '@material-ui/core';

import { useCustomTheme } from '@/hooks/useCustomTheme';

interface PricingTagProps {
  tag: string;
  onDelete?: () => void;
}

export const PricingTag = ({ tag, onDelete }: PricingTagProps) => {
  const { palette } = useCustomTheme();
  return (
    <Chip
      label={tag}
      variant={'default'}
      style={{
        marginRight: '6px',
        marginTop: '6px',
        backgroundColor: palette.grey[100],
        color: palette.text.primary,
      }}
      onDelete={onDelete ? onDelete : undefined}
    />
  );
};
